// extracted by mini-css-extract-plugin
export default {"dialog":"MultiSelectionDialog_dialog__WR0tl"};